/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Injectable, inject } from '@angular/core';
import { DatabaseService } from '../../db/database.service';
import { DatabaseHelper } from '../../db/database-helper';
import { StorageRequestFactory } from './storage-request-factory';
import { StorageRequest } from './storage-request';
import { AppConfig } from '../../app-config';
import { Observable } from 'rxjs';
import { CookieService } from '../../../service/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private db = inject(DatabaseService);
  private cookie = inject(CookieService);
  private config = inject(AppConfig);

  private factory = new StorageRequestFactory();

  constructor() {
    this.db.subscribe((helper) => {
      if (helper && this.config.cache) {
        this.clear(helper);
      }
    });
  }

  public store(url: string, method: 'GET' | 'OPTIONS', data: any) {
    let token = this.cookie.get('witoken');
    if (!token) {
      token = 'noToken';
    }
    const request = new StorageRequest(url, method, token, data, new Date());
    this.db.getDataBaseHelper((helper) => {
      helper.store(this.factory.getStorageName(), [request]);
    });
  }

  public get(
    url: string,
    method: 'GET' | 'OPTIONS'
  ): Observable<StorageRequest> {
    return new Observable<StorageRequest>((obs) => {
      let token = this.cookie.get('witoken');
      if (!token) {
        token = 'noToken';
      }
      this.db.getDataBaseHelper((helper) => {
        helper.getById(this.factory, [url, token, method]).subscribe(
          (result) => {
            if (result && this.checkValidity(result)) {
              obs.next(result);
            } else {
              obs.next(null);
            }
            obs.complete();
          },
          () => {
            obs.next(null);
            obs.complete();
          }
        );
      });
    });
  }

  public clear(helper: DatabaseHelper) {
    const validity = new Date().getTime() - this.config.cache * 1000;
    const key = IDBKeyRange.upperBound(validity);
    helper.removeByIndex(
      this.factory.getStorageName(),
      this.factory.getIndexName(),
      key
    );
  }

  private checkValidity(request: StorageRequest) {
    const validity = new Date().getTime() - this.config.cache * 1000;
    if (request.stamp.getTime() >= validity) {
      return true;
    } else {
      this.db.getDataBaseHelper((helper) => {
        helper.remove(this.factory.getStorageName(), [
          request.url,
          request.token,
          request.method,
        ]);
      });
    }
    return false;
  }
}
